import React from 'react';

import './Services.css';
import API from "../../components/api";
import Utils from "../../utils";


class ServicesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            search: ''
        }

        this.handleSearch = (e) => {
            this.setState({search: e.target.value})
        }

        this.formatNumber = (number) => {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }

        this.formatPrice = (service) => {
            if (service.price_type === 'fix')
                return <div className="price">
                    <div className="from">{this.formatNumber(service.price_from)} ₽</div>
                </div>

            else if (service.price_type === 'from-to')
                return <div className="price">
                    <div className="from">от {this.formatNumber(service.price_from)} ₽</div>
                    <div className="to">до {this.formatNumber(service.price_to)} ₽</div>
                </div>

            else if (service.price_type === 'only-from')
                return <div className="price">
                    <div className="from">от {this.formatNumber(service.price_from)} ₽</div>
                </div>

            else if (service.price_type === 'free')
                return <div className="price">
                    <div className="from">Бесплатно</div>
                </div>

            return <div className="price">
                <div className="from">от {this.formatNumber(service.price_from)} ₽</div>
                <div className="to">до {this.formatNumber(service.price_to)} ₽</div>
            </div>
        }

        this.filterCategories = () => {
            const {categories, search} = this.state;

            if (!search.trim()) return categories;

            const q = search.toLowerCase();

            return categories
                .map(category => {
                    const services = category.services.filter(s =>
                        s.name.toLowerCase().includes(q)
                    );

                    const subcategories = category.subcategories
                        .map(sub => {
                            const subServices = sub.services.filter(s =>
                                s.name.toLowerCase().includes(q)
                            );

                            if (!subServices.length) return null;

                            return {
                                ...sub,
                                services: subServices
                            };
                        })
                        .filter(Boolean);

                    if (!services.length && !subcategories.length) return null;

                    return {
                        ...category,
                        services,
                        subcategories
                    };
                })
                .filter(Boolean);
        }

        this.renderCategories = (categories) => {
            const countServices = (category) => {
                let count = category.services.length;
                category.subcategories.forEach(sub => {
                    count += sub.services.length;
                });
                return count;
            };

            // Считаем количество услуг для каждой категории
            const categoriesWithCount = categories.map(cat => ({
                ...cat,
                serviceCount: countServices(cat)
            }));

            // Ищем середину по количеству услуг
            const totalServices = categoriesWithCount.reduce((sum, cat) => sum + cat.serviceCount, 0);
            let sum = 0;
            let middleIndex = 0;

            for (let i = 0; i < categoriesWithCount.length; i++) {
                sum += categoriesWithCount[i].serviceCount;
                if (sum >= Math.ceil(totalServices / 2)) {
                    middleIndex = i + 1; // +1 чтобы включить текущую категорию в первую половину
                    break;
                }
            }

            const firstHalf = categoriesWithCount.slice(0, middleIndex);
            const secondHalf = categoriesWithCount.slice(middleIndex);

            return (
                <>
                    <div className="wrap">
                        {firstHalf.map(category => (
                            <div className="category" key={category.id}>
                                <div className="header">{category.name}</div>
                                <div className="list">
                                    {category.services.map(service => (
                                        <div className="service" key={service.id}>
                                            <div className="label">{service.name}</div>
                                            {this.formatPrice(service)}
                                        </div>
                                    ))}
                                    {category.subcategories.map(subcategory => {
                                        return <div className='subcategory'>
                                            <div className="header">{subcategory.name}</div>
                                            <div className="list">
                                                {subcategory.services.map(service => (
                                                    <div className="service" key={service.id}>
                                                        <div className="label">{service.name}</div>
                                                        {this.formatPrice(service)}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="wrap">
                        {secondHalf.map(category => (
                            <div className="category" key={category.id}>
                                <div className="header">{category.name}</div>
                                <div className="list">
                                    {category.services.map(service => (
                                        <div className="service" key={service.id}>
                                            <div className="label">{service.name}</div>
                                            {this.formatPrice(service)}
                                        </div>
                                    ))}
                                    {category.subcategories.map(subcategory => {
                                        return <div className='subcategory'>
                                            <div className="header">{subcategory.name}</div>
                                            <div className="list">
                                                {subcategory.services.map(service => (
                                                    <div className="service" key={service.id}>
                                                        <div className="label">{service.name}</div>
                                                        {this.formatPrice(service)}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            );
        }
    }

    componentDidMount() {
        Utils.setPageTitle('Услуги')

        API.getServicesPage()
            .then(data => this.setState({categories: data}))
            .catch(() => {
            })
    }

    render() {
        return <div className='services-page'>
            <div className='page'>
                <div className='header'>
                    <div className='title'>
                        Все услуги
                    </div>
                    <div className='search'>
                        <input placeholder='Поиск по названию' value={this.state.search}
                               onChange={this.handleSearch}/>
                    </div>
                </div>
                <div className="catalog">
                    {
                        this.renderCategories(this.filterCategories())
                    }
                </div>
            </div>
        </div>
    }
}


export default ServicesPage;
